import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Modal, Select } from 'antd';
import * as actions from '../redux/actions/employee';

class EditEmployee extends React.Component {

    state = {
        confirmLoading: false,
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };

    onFinish = async (values) => {
        let user = {
            id: this.props.editEmployee.id,
            name: values.name,
            username: values.username,
            roles: [values.role],
        }
        console.log('user',user);
        await this.props.onUpdate(user, this.props.token);
        this.setState(prevState => {
            return {
                ...prevState,
                confirmLoading: true,
            }
        });
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    confirmLoading: false,
                }
            });
            if (this.props.editMessage) {
                message.success(this.props.editMessage);
            }
            if (this.props.editError) {
                message.error(this.props.editError);
            }
            this.props.onCloseForm();
            this.props.onClear();
        }, 400)
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel = () => {
        this.props.onCloseForm();
    }
    render() {
        const { Option } = Select;
        const roles = this.props.roles.map(role => {
            return (
                <Option key={role.id} value={role.id}>{role.name}</Option>
            );
        })
        let filterRole = this.props.roles.filter(role => role.name == this.props.editEmployee.role);
        let initialRole = null;
        for (let i in filterRole) {
            initialRole = filterRole[i].id;
        }
        return (
            <Modal
                title="Edit User"
                key={this.props.editEmployee.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'edit-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="edit-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        name: this.props.editEmployee.name,
                        username: this.props.editEmployee.username,
                        role: initialRole,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                            {
                                required: true,
                                message: 'Require name!',
                            },
                            { min: 4, message: 'Minimum 4 characters.' },
                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="username"
                        label="Username"
                        rules={[
                            {
                                required: true,
                                message: 'require username!',
                            },
                            { min: 4, message: 'Minimum 4 characters.' },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="role"
                        label="Role"
                        rules={
                            [{
                                required: true,
                                message: 'Require role',
                            }]
                        }
                    >
                        <Select
                            style={{ width: 180 }}
                        >
                            {roles}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        editMessage: state.employee.message,
        editError: state.employee.error,
        visible: state.employee.visibleEditForm,
        editEmployee: state.employee.editEmployee,
        roles: state.roles.roles,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeEditForm()),
        onClear: () => dispatch(actions.clearEdit()),
        onUpdate: (user, token) => dispatch(actions.updateUser(user, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditEmployee);